<template lang="pug">
  SspLayout(area="core")
    SspSaveForm(@onSubmit="save" :saving="saving")
      .row.section-edit
        .col-md-8
          .panel.panel-default
            .panel-heading
              .panel-title Range
            .panel-body
              form.form-horizontal
                .form-group
                  label.col-sm-2.control-label Start Code
                  .col-sm-4
                    input.kzcode-default.form-control.start-code(v-model="firstCode" @input="firstCodeInput($event.target.value)" type="text")
                  label.col-sm-2.control-label Index
                  .col-sm-4
                    input.form-control.start-code(v-model.number="firstCodeIndex" @input="firstCodeIndexInput($event.target.value)" type="number")
                .form-group
                  label.col-sm-2.control-label Last Code
                  .col-sm-4
                    input.kzcode-default.form-control.end-code(v-model="lastCode" @input="lastCodeInput($event.target.value)" type="text")
                  label.col-sm-2.control-label Index
                  .col-sm-4
                    input.form-control.end-code(v-model.number="lastCodeIndex" @input="lastCodeIndexInput($event.target.value)" type="number")
                .form-group
                  .col-sm-6
                  label.col-sm-2.control-label Size
                  .col-sm-4
                    input.form-control.section-size(:value="sectionSize" :disabled="true")

          .panel.panel-default
            .panel-heading
              .panel-title Properties
            .panel-body
              form.form-horizontal
                .form-group
                  label.col-sm-2.control-label Product
                  .col-sm-10
                    ProductSelect(v-model="productId")
                .form-group
                  label.col-sm-2.control-label Schema
                  .col-sm-10
                    MetadataSchemaSelect(ref="metadataSchemaSelect" v-model="schemaId")
                .form-group
                  label.col-sm-2.control-label Comment
                  .col-sm-10
                    textarea.form-control(v-model="comment")

        .col-sm-4
          ActivateForValidation(v-model="activation")

        .col-sm-4
          span.error-handling(v-if="errorMsg") {{errorMsg}}

    ChangeAtiGroupModal(ref="changeAtiGroupModal" @close="redirect()" :sectionId="sectionId" :atiGroupId="atiGroupId" @error="$emit('error', $event)")

</template>

<script>
import debounce from 'debounce'
import miniToastr from 'mini-toastr'
import ActivateForValidation from '@/components/ssp/ActivateForValidation'
import Core from '@/service/apis/Core'
import Masterdata from '@/service/apis/Masterdata'
import ProductSelect from '@/components/ssp/ProductSelect'
import MetadataSchemaSelect from '@/components/ssp/MetadataSchemaSelect'
import DatePicker from '@/components/common/Datepicker'
import Util from '@/service/Util'
import ChangeAtiGroupModal from './ChangeAtiGroupModal'


export default {
  data: () => ({
    saving: false,
    productId: null,
    schemaId: null,
    firstCode: null,
    firstCodeIndex: null,
    lastCode: null,
    lastCodeIndex: null,
    section: null,
    comment: null,
    errorMsg: null,
    atiGroupId: null,
    isNew: true,
    activation: {
      maxValidations: null,
      enabled: false,
      activateDate: null,
      deactivateDate: null,
    }
  }),
  created() {
    if (this.$route.params.sectionId) {
      this.isNew = false
    }
    if (!this.isNew) {
      Core.getSection(this.sectionId)
        .then((resp) => {
          this.section = resp.data
          if (resp.data.product) {
            this.productId = resp.data.product.id
          }
          if (resp.data.metadata) {
            this.schemaId = resp.data.metadata.schema.id
          }
          this.firstCodeIndex = resp.data.first.codeIndex
          this.lastCodeIndex = resp.data.last.codeIndex
          this.firstCode = resp.data.first.code
          this.lastCode = resp.data.last.code
          this.comment = resp.data.comment

          this.activation.enabled = resp.data.enabled
          this.activation.maxValidations = resp.data.maxValidations
          this.activation.activateDate = resp.data.activateDate
          this.activation.deactivateDate = resp.data.deactivateDate
        })
        .catch((e) => { this.errorMsg = this.emitError(e) })
    }

    if (this.$route.query.min >= 0) {
      this.firstCodeIndex = this.$route.query.min
      this.lastCodeIndex = this.$route.query.max
      this.lastCodeIndexInput(this.lastCodeIndex)
      this.firstCodeIndexInput(this.firstCodeIndex)
    }

    this.firstCodeIndexInput = debounce(this.firstCodeIndexInput, 500)
    this.lastCodeIndexInput = debounce(this.lastCodeIndexInput, 500)
    this.firstCodeInput = debounce(this.firstCodeInput, 1000)
    this.lastCodeInput = debounce(this.lastCodeInput, 1000)
  },
  methods: {
    save() {
      if (this.sectionSchemaRemovedAndHasData) {
        this.$confirm({ text: 'This will remove previously stored metadata. Continue?' })
          .then((conf) => {
            if (conf) {
              Core.deleteOrderSectionMetadata(this.orderId, this.sectionId)
                .then(() => {
                  this.doSave()
                })
            }
          })
      } else {
        this.doSave()
      }
    },
    redirect() {
      const action = this.isNew ? 'created' : 'updated'
      this.$router.push(this.isNew ? { name: 'sections', params: { id: this.orderId } } : { name: 'section', params: { orderId: this.orderId, sectionId: this.sectionId } })
      miniToastr.success(`Section was successfully ${action}`)
    },
    doSave() {
      this.saving = true
      const req = this.createPayload()
      const call = this.isNew ? Core.createSection(req) : Core.updateSection(this.sectionId, req)

      call
        .then(() => {
          if (!this.isNew && this.productChange === true) {
            Masterdata.getProduct(this.productId)
              .then((resp) => resp.data.product.atiGroupId)
              .then((atiGroupId) => {
                if (atiGroupId) {
                  this.atiGroupId = atiGroupId
                  this.promtUser()
                } else {
                  this.redirect()
                }
              })
              .catch((e) => {
                this.$emit('error', e)
              })
          } else {
            this.redirect()
          }
        })
        .catch((e) => {
          this.$emit('error', e)
        })
        .then(() => {
          this.saving = false
        })
    },
    createPayload() {
      const req = {}
      req.startIndex = parseInt(this.firstCodeIndex, 10) + 1
      req.endIndex = parseInt(this.lastCodeIndex, 10) + 1

      if (this.schemaId) {
        const selectedSchema = this.$refs.metadataSchemaSelect.getSelectedMetadataschema()
        req.metadataSchema = selectedSchema.name
      }
      if (this.productId) {
        req.productId = this.productId
      }
      if (this.activation.activateDate) {
        req.activateDate = this.activation.activateDate
      }
      if (this.activation.deactivateDate) {
        req.deactivateDate = this.activation.deactivateDate
      }
      if (this.comment) {
        req.comment = this.comment
      }

      req.maxValidations = this.activation.maxValidations
      req.enabled = this.activation.enabled
      req.orderId = this.orderId
      if (this.sectionId) {
        req.id = this.sectionId
      }
      return req
    },
    promtUser() {
      this.$refs.changeAtiGroupModal.open()
    },
    firstCodeIndexInput(firstCodeIndex) {
      const req = { max: 1, offset: firstCodeIndex }
      return Core.getCodeByIndex(this.orderId, req)
        .then((resp) => {
          [this.firstCode] = resp.data.codes
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    lastCodeIndexInput(lastCodeIndex) {
      const req = { max: 1, offset: lastCodeIndex }
      return Core.getCodeByIndex(this.orderId, req)
        .then((resp) => {
          [this.lastCode] = resp.data.codes
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    firstCodeInput(firstCode) {
      return Core.codeInfo(Util.sanitizeCode(firstCode))
        .then((resp) => {
          this.firstCodeIndex = resp.data.length > 0 ? resp.data[0].codeIndex : null
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    lastCodeInput(lastCode) {
      return Core.codeInfo(Util.sanitizeCode(lastCode))
        .then((resp) => {
          this.lastCodeIndex = resp.data.length > 0 ? resp.data[0].codeIndex : null
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    }
  },
  computed: {
    sectionSchemaRemovedAndHasData() {
      if (!this.isNew && this.schemaId === null && this.section.metadata && this.section.metadata.schema && this.section.metadata.schema.id !== null && this.section.metadata.data) {
        return true
      }
      return false
    },
    sectionSize() {
      return (this.lastCodeIndex - this.firstCodeIndex) + 1
    },
    productChange() {
      if (this.productId && this.section.product) {
        return this.section.product.id !== this.productId
      }
      return false
    },
    orderId() {
      return parseInt(this.$route.params.orderId, 10)
    },
    sectionId() {
      return parseInt(this.$route.params.sectionId, 10)
    }
  },
  components: {
    ProductSelect,
    MetadataSchemaSelect,
    DatePicker,
    ChangeAtiGroupModal,
    ActivateForValidation
  }
}
</script>

<style lang="scss">
.activation-checkbox,
.section-size {
  padding-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/order/section/EditSection.vue